import { assertNotEmpty } from '@festina-life/core'
import { useCallback } from 'react'
import { useNavigate } from 'react-router'

import { useParameterContext } from '../../context/parameterContext'
import { configurationItem } from '../../system/paths'
import { useNavigationParams } from '../../system/useNavigationParams'
import { useWorkspaceManagerContext } from '../../workspace/workspaceManagerContext'

export const useNavigateToCurrentParameterDefinitionPath = () => {
  const navigate = useNavigate()
  const { currentWorkspaceKey } = useWorkspaceManagerContext()
  const { server, branch } = useNavigationParams()
  const { parameterDefinitionOperation } = useParameterContext()

  return useCallback(
    async (path: string) => {
      assertNotEmpty(
        parameterDefinitionOperation?.internalOperation.entity?.name,
      )

      await navigate(
        configurationItem({
          path,
          branch,
          type: 'parameterDefinition',
          server,
          workspaceName: currentWorkspaceKey?.name,
          layer: parameterDefinitionOperation.layer,
          block: parameterDefinitionOperation.block,
          itemId: parameterDefinitionOperation.internalOperation.entity.name,
        }),
      )
    },
    [
      parameterDefinitionOperation?.internalOperation.entity?.name,
      parameterDefinitionOperation?.layer,
      parameterDefinitionOperation?.block,
      navigate,
      branch,
      server,
      currentWorkspaceKey?.name,
    ],
  )
}
